import MobileFallback from './MobileFallback';

export default MobileFallback;
